(function () {
  if (window.ChefK9OrderSchedulingInitialized) return;
  window.ChefK9OrderSchedulingInitialized = true;

  const BOX_SELECTOR = '.ck-order-scheduling';

  let emptyCartCheckRunning = false;
  let refreshQueued = false;

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  function getMinimumDate(skipWeekends) {
    const now = new Date();
    const earliest = new Date();

    // Orders placed at or after 3 PM begin with the next day.
    if (now.getHours() >= 15) {
      earliest.setDate(earliest.getDate() + 1);
    }

// Chef K9 does not offer delivery or pickup on Sunday.
if (skipWeekends) {
  while (earliest.getDay() === 0) {
    earliest.setDate(earliest.getDate() + 1);
  }
}

    return formatDate(earliest);
  }

  function isWeekend(value) {
    if (!value) return false;

    const parts = value.split('-');

    const date = new Date(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2])
    );

    return date.getDay() === 0;
  }

  function validateBox(box) {
    const selected = box.querySelector(
      'input[name="attributes[Fulfillment Preference]"]:checked'
    );

    const deliveryDate = box.querySelector('.ck-delivery-date');
    const pickupDate = box.querySelector('.ck-pickup-date');
    const pickupTime = box.querySelector('.ck-pickup-time');

    if (!selected) {
      return {
        valid: false,
        message:
          'Please choose Local Delivery or Curbside Pickup to continue.'
      };
    }

    if (selected.value === 'Local Delivery') {
      if (!deliveryDate || !deliveryDate.value) {
        return {
          valid: false,
          message: 'Please select your delivery date to continue.'
        };
      }

      if (isWeekend(deliveryDate.value)) {
        return {
          valid: false,
          message:
           'Delivery is unavailable on Sunday. Please choose Monday-Saturday.'
        };
      }
    }

    if (selected.value === 'Curbside Pickup') {
      if (!pickupDate || !pickupDate.value) {
        return {
          valid: false,
          message: 'Please select your pickup date to continue.'
        };
      }

if (isWeekend(pickupDate.value)) {
  return {
    valid: false,
    message: 'Pickup is unavailable on Sunday. Please choose Monday-Saturday.'
  };
}

      if (!pickupTime || !pickupTime.value) {
        return {
          valid: false,
          message: 'Please select your pickup time to continue.'
        };
      }
    }

    if (box.dataset.saving === 'true') {
      return {
        valid: false,
        message: 'Saving your selection...'
      };
    }

    return {
      valid: true,
      message: ''
    };
  }

  function updateBox(box) {
    if (!box) return;

    const deliveryFields = box.querySelector('.ck-delivery-fields');
    const pickupFields = box.querySelector('.ck-pickup-fields');

    const deliveryDate = box.querySelector('.ck-delivery-date');
    const pickupDate = box.querySelector('.ck-pickup-date');

    const status = box.querySelector('.ck-scheduling-status');

    const selected = box.querySelector(
      'input[name="attributes[Fulfillment Preference]"]:checked'
    );

    if (deliveryDate) {
      deliveryDate.min = getMinimumDate(true);
    }

    if (pickupDate) {
      pickupDate.min = getMinimumDate(false);
    }

    if (deliveryFields) {
      deliveryFields.classList.remove('is-active');
    }

    if (pickupFields) {
      pickupFields.classList.remove('is-active');
    }

    if (selected && selected.value === 'Local Delivery') {
      if (deliveryFields) {
        deliveryFields.classList.add('is-active');
      }
    }

    if (selected && selected.value === 'Curbside Pickup') {
      if (pickupFields) {
        pickupFields.classList.add('is-active');
      }
    }

    const result = validateBox(box);

const shouldShowMessage =
  box.dataset.checkoutAttempted === 'true' ||
  box.dataset.saving === 'true';

if (status) {
  let message = '';

  if (shouldShowMessage) {
    message = result.message;

    if (
      !box.querySelector(
        'input[name="attributes[Fulfillment Preference]"]:checked'
      )
    ) {
      message =
        'Before continuing to checkout, please select Local Delivery or Curbside Pickup.';
    }
  }

  status.textContent = message;
  status.style.display = message ? 'block' : 'none';
}

    const summary = box.closest('.cart-summary__inner');

    if (!summary) return;

    const checkoutButton =
      summary.querySelector('.cart__checkout-button');

    const acceleratedButtons =
      summary.querySelector('.additional-checkout-buttons');

    if (checkoutButton) {
      checkoutButton.classList.toggle(
        'ck-checkout-locked',
        !result.valid
      );

      checkoutButton.setAttribute(
        'aria-disabled',
        result.valid ? 'false' : 'true'
      );
    }

    if (acceleratedButtons) {
      if (result.valid) {
        acceleratedButtons.style.removeProperty('display');
      } else {
        acceleratedButtons.style.setProperty(
          'display',
          'none',
          'important'
        );
      }
    }
  }

  function updateAllBoxes() {
    document.querySelectorAll(BOX_SELECTOR).forEach(function (box) {
      updateBox(box);
    });
  }

  function getBoxForCheckout(button) {
    const summary = button.closest('.cart-summary__inner');

    if (summary) {
      const box = summary.querySelector(BOX_SELECTOR);

      if (box) return box;
    }

    return Array.from(
      document.querySelectorAll(BOX_SELECTOR)
    ).find(function (box) {
      return box.offsetParent !== null;
    });
  }

  async function saveAttributes(box) {
    const selected = box.querySelector(
      'input[name="attributes[Fulfillment Preference]"]:checked'
    );

    const deliveryDate = box.querySelector('.ck-delivery-date');
    const pickupDate = box.querySelector('.ck-pickup-date');
    const pickupTime = box.querySelector('.ck-pickup-time');

    const attributes = {
      'Fulfillment Preference': selected ? selected.value : '',
      'Preferred Delivery Date': '',
      'Pickup Date': '',
      'Pickup Time': ''
    };

    if (selected && selected.value === 'Local Delivery') {
      attributes['Preferred Delivery Date'] =
        deliveryDate ? deliveryDate.value : '';
    }

    if (selected && selected.value === 'Curbside Pickup') {
      attributes['Pickup Date'] =
        pickupDate ? pickupDate.value : '';

      attributes['Pickup Time'] =
        pickupTime ? pickupTime.value : '';
    }

    box.dataset.saving = 'true';
    updateBox(box);

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: attributes
        })
      });
    } catch (error) {
      console.error(
        'Chef K9 scheduling save failed:',
        error
      );
    } finally {
      box.dataset.saving = 'false';
      updateBox(box);
    }
  }

  async function clearSchedulingIfCartEmpty() {
    if (emptyCartCheckRunning) return;

    emptyCartCheckRunning = true;

    try {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      const cart = await response.json();

      if (cart.item_count !== 0) return;

      const attributes = cart.attributes || {};

      const hasOldScheduling =
        attributes['Fulfillment Preference'] ||
        attributes['Preferred Delivery Date'] ||
        attributes['Pickup Date'] ||
        attributes['Pickup Time'];

      if (!hasOldScheduling) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Fulfillment Preference': '',
            'Preferred Delivery Date': '',
            'Pickup Date': '',
            'Pickup Time': ''
          }
        })
      });
    } catch (error) {
      console.error(
        'Chef K9 empty cart cleanup failed:',
        error
      );
    } finally {
      emptyCartCheckRunning = false;
    }
  }

  function refreshScheduling() {
    updateAllBoxes();
    clearSchedulingIfCartEmpty();
  }

  function queueRefresh() {
    if (refreshQueued) return;

    refreshQueued = true;

    requestAnimationFrame(function () {
      refreshQueued = false;
      refreshScheduling();
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      const checkoutButton =
        event.target.closest('.cart__checkout-button');

      if (!checkoutButton) return;

      const box = getBoxForCheckout(checkoutButton);

      // Subscription cart = no scheduling box.
      if (!box) return;

      const result = validateBox(box);

   if (!result.valid) {
  box.dataset.checkoutAttempted = 'true';

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  updateBox(box);

        box.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      const submitter = event.submitter;

      if (
        !submitter ||
        !submitter.classList.contains(
          'cart__checkout-button'
        )
      ) {
        return;
      }

      const box = getBoxForCheckout(submitter);

      if (!box) return;

      const result = validateBox(box);

      if (!result.valid) {
        box.dataset.checkoutAttempted = 'true';
        
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        updateBox(box);

        box.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },
    true
  );

  document.addEventListener('change', function (event) {
    const box = event.target.closest(BOX_SELECTOR);

    if (!box) return;

    if (
      !event.target.matches(
        'input[name="attributes[Fulfillment Preference]"], .ck-delivery-date, .ck-pickup-date, .ck-pickup-time'
      )
    ) {
      return;
    }

    const selected = box.querySelector(
      'input[name="attributes[Fulfillment Preference]"]:checked'
    );

    const deliveryDate =
      box.querySelector('.ck-delivery-date');

    const pickupDate =
      box.querySelector('.ck-pickup-date');

    const pickupTime =
      box.querySelector('.ck-pickup-time');

    if (
      selected &&
      selected.value === 'Local Delivery'
    ) {
      if (pickupDate) pickupDate.value = '';
      if (pickupTime) pickupTime.value = '';
    }

    if (
      selected &&
      selected.value === 'Curbside Pickup'
    ) {
      if (deliveryDate) deliveryDate.value = '';
    }

    updateBox(box);
    saveAttributes(box);
  });

  function mutationContainsCartUI(mutation) {
    const nodes = [
      ...mutation.addedNodes,
      ...mutation.removedNodes
    ];

    return nodes.some(function (node) {
      if (node.nodeType !== 1) return false;

      if (
        node.matches &&
        node.matches(
          '.ck-order-scheduling, .cart__ctas'
        )
      ) {
        return true;
      }

      return Boolean(
        node.querySelector &&
        node.querySelector(
          '.ck-order-scheduling, .cart__ctas'
        )
      );
    });
  }

  function start() {
    refreshScheduling();

    const observer = new MutationObserver(function (mutations) {
      if (mutations.some(mutationContainsCartUI)) {
        queueRefresh();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();